var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLegalHammer = function SvgLegalHammer(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5894 31.6716L17.0964 19.1787L19.1786 17.0966L31.6715 29.5895L29.5894 31.6716Z",
    fill: "#F98979"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.64453 13.9727L13.9731 5.64404L23.3428 15.0137L15.0142 23.3423L5.64453 13.9727ZM9.80884 13.9727L15.0142 19.178L19.1785 15.0137L13.9731 9.80835L9.80884 13.9727Z",
    fill: "#F98979"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20364 23.7786C9.88487 24.4598 11.0257 24.3155 11.5158 23.4861L13.4492 20.2141L15.9843 21.7121L14.0509 24.9841C12.5821 27.4698 9.16307 27.9023 7.12149 25.8607L3.12652 21.8658C1.08494 19.8242 1.51749 16.4052 4.00319 14.9364L7.27515 13.0029L8.77316 15.538L5.5012 17.4715C4.67178 17.9616 4.52745 19.1024 5.20868 19.7836L9.20364 23.7786Z",
    fill: "#F98979"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7837 5.20872C19.1024 4.5275 17.9616 4.67183 17.4715 5.50124L15.5381 8.7732L13.003 7.27519L14.9364 4.00323C16.4052 1.51753 19.8242 1.08498 21.8658 3.12657L25.8608 7.12153C27.9024 9.16312 27.4698 12.5821 24.9841 14.0509L21.7122 15.9844L20.2141 13.4493L23.4861 11.5159C24.3155 11.0257 24.4599 9.88491 23.7786 9.20369L19.7837 5.20872Z",
    fill: "#F98979"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6756 35.343H1.48022V32.3984H17.6756V35.343Z",
    fill: "#F98979"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLegalHammer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/legal-hammer.e373c553.svg";
export { ForwardRef as ReactComponent };